Vue.component(//问答首页
    'fqa-index',
    resolve => require(["../../components/fqa"], resolve)
);
Vue.component(//自助排障
    'fqa-handbook',
    resolve => require(["../../components/fqa/handbook"], resolve)
);
Vue.component(//问答提问
    'fqa-quiz',
    resolve => require(["../../components/fqa/quiz"], resolve)
);
Vue.component(//问答文章详情
    'fqa-detail',
    resolve => require(["../../components/fqa/detail"], resolve)
);
Vue.component(//问答视频列表
    'fqa-video-box',
    resolve => require(["../../components/fqa/videoBox"], resolve)
);
Vue.component(//问答文章列表
    'fqa-squeeze-box',
    resolve => require(["../../components/fqa/squeezeBox"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/fqa.js